import { format } from 'date-fns'

export const dateFormat = 'yyyy-MM-dd'
export const timeFormat = 'HH:mm'
export const dateTimeFormat = `${dateFormat} ${timeFormat}`

export const formatDateTime = (date: string | number) => format(new Date(date), dateTimeFormat)
